import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './Home.js'
import About from './About.js'
import NoPage from './NoPage.js'
import Test from './Test.js'
import PhotoPage from './PhotoPage.js'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path={'/about'} element={<About />} />
        <Route path={'/test'} element={<Test />} />
        <Route path={'/photography'} element={<PhotoPage />} />
        <Route path={'*'} element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
